/**
 * Support Domain — Public API (Barrel Export)
 *
 * All support/explanation content resolution, hints, and coverage reporting.
 * External consumers should import from this barrel only.
 */

// Types
export type {
  ExplanationContent,
  CheatSheetContent,
  ResolvedSupport,
  SupportCoverage,
  FamilySupportDefinition,
  SeedSupportDefinition,
} from './types'
export { calculateCoverage } from './types'

// Hint types
export type { HintStep, HintVisual, SubSkillHint } from './hints'

// Support resolver
export { resolveSupportContent, resolveUnifiedSupport } from './supportResolver'
export type { QuestionResolvedSupport } from './supportResolver'

// Family support registry
export {
  FAMILY_SUPPORT_REGISTRY,
  getFamilySupportEntry,
  getHintsForFamilyId,
  getAllSupportedFamilyIds,
} from './familySupportRegistry'
export type {
  FamilySupportEntry,
  RepresentationSupport,
} from './familySupportRegistry'

// Coverage reporting
export {
  generateSupportCoverageReport,
  assertSupportCoverage,
} from './supportCoverageReport'
export type {
  SupportCoverageReport,
  FamilyCoverageStatus,
} from './supportCoverageReport'
